import React from 'react';
export function Footer() {
  return <footer className="bg-white py-8 text-center text-xs px-4 border-t border-gray-100" data-id="element-53">
      <div className="max-w-5xl mx-auto" data-id="element-54">
        <p className="font-heading font-bold text-headline/60 text-sm mb-2" data-id="element-55">
          Pilates Italia Elite
        </p>
        <p className="text-body/40 font-light" data-id="element-56">
          &copy; {new Date().getFullYear()} Tutti i diritti riservati. Questo
          sito non fa parte del sito Facebook o Facebook Inc.
        </p>
      </div>
    </footer>;
}